import script from "./role.vue?vue&type=script&setup=true&lang=js"
export * from "./role.vue?vue&type=script&setup=true&lang=js"

import "./role.vue?vue&type=style&index=0&id=3244e7c6&lang=scss"

const __exports__ = script;

export default __exports__